import React, { FC } from "react";

import { Channel as ChannelType, ChannelBox, ChannelLogo } from "planby";

interface Props {
    channel: ChannelType;
}

const Channel: FC<Props> = ({
    channel,
}: Props) => {
    const { position, logo } = channel;
    return (
        <ChannelBox {...position}>
            {/* Overwrite styles by add eg. style={{ maxHeight: 52, maxWidth: 52,... }} */}
            {/* Or stay with default styles */}
            <ChannelLogo
                src={logo}
                alt="Logo"
                style={{ maxHeight: 52, maxWidth: 52 }}
            />
        </ChannelBox>
    );
};

export default Channel;